import { type EventMappers, registerGa4Events } from '../../tracking/dataLayerAdapter';
import type { ChangeEmailErrorCode, ChangePasswordErrorCode } from './errorCodes';

export type EmailChangeFailedReason = ChangeEmailErrorCode | 'unknown';
export type PasswordChangeFailedReason = ChangePasswordErrorCode | 'unknown';

declare module '@platform/tracking' {
  interface TrackingEvents {
    email_change_completed: Record<string, never>;
    email_change_failed: { reason: EmailChangeFailedReason };
    email_change_form_viewed: Record<string, never>;
    email_change_field_focused: Record<string, never>;
    email_change_form_abandoned: Record<string, never>;
    password_change_completed: Record<string, never>;
    password_change_failed: { reason: PasswordChangeFailedReason };
  }
}

// Truth source: BI tracking spec (Google Sheet, CSC tab) — event_name=`account_settings`
// with `*_started`/`*_completed`/`*_failed` descriptions. The *_field_focused and
// *_form_abandoned descriptions are not yet in the spec; emitted as in-house signals
// pending BI sign-off.
export const accountGa4EventMappers: EventMappers = {
  email_change_completed: () => ({
    event: 'account_settings',
    event_description: 'email_change_completed',
  }),
  email_change_failed: (p) => ({
    event: 'account_settings',
    event_description: 'email_change_failed',
    event_details: p.reason,
  }),
  email_change_form_viewed: () => ({
    event: 'account_settings',
    event_description: 'email_change_started',
  }),
  // Not in BI spec yet — in-house signal.
  email_change_field_focused: () => ({
    event: 'account_settings',
    event_description: 'email_change_field_focused',
  }),
  // Not in BI spec yet — in-house signal.
  email_change_form_abandoned: () => ({
    event: 'account_settings',
    event_description: 'email_change_form_abandoned',
  }),
  password_change_completed: () => ({
    event: 'account_settings',
    event_description: 'password_change_completed',
  }),
  password_change_failed: (p) => ({
    event: 'account_settings',
    event_description: 'password_change_failed',
    event_details: p.reason,
  }),
};

registerGa4Events(accountGa4EventMappers);
